import { useState } from 'react';

function BrandPersonality({ onComplete }) {
  const [traits, setTraits] = useState([]);
  const [newTrait, setNewTrait] = useState('');

  const handleAddTrait = (e) => {
    e.preventDefault();
    if (newTrait.trim()) {
      setTraits(prev => [...prev, newTrait.trim()]);
      setNewTrait('');
    }
  };

  const handleRemoveTrait = (index) => {
    setTraits(prev => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onComplete(true);
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="flex items-center space-x-2 mb-6">
        <span className="text-purple-500">😊</span>
        <h2 className="text-lg font-medium">Personality</h2>
      </div>
      <p className="text-sm text-gray-600 mb-6">
        Describe the personality of your brand. This helps in establishing a consistent tone and style in communication.
      </p>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Brand Personality
          </label>
          <p className="text-sm text-gray-500 mb-4">
            What is the personality of the brand? How do you want customers to perceive your brand emotionally? (Press enter to add a new personality trait)
          </p>

          <div className="space-y-4">
            <div className="flex">
              <input
                type="text"
                value={newTrait}
                onChange={(e) => setNewTrait(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleAddTrait(e);
                  }
                }}
                placeholder="Add new personality trait"
                className="flex-1 rounded-l-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              />
              <button
                type="button"
                onClick={handleAddTrait}
                className="px-4 py-2 bg-[#0049ac] text-white rounded-r-lg hover:bg-[#0049ac]/90"
              >
                Add
              </button>
            </div>

            <div className="flex flex-wrap gap-2">
              {traits.map((trait, index) => (
                <span
                  key={index}
                  className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800"
                >
                  {trait}
                  <button
                    type="button"
                    onClick={() => handleRemoveTrait(index)}
                    className="ml-2 inline-flex items-center justify-center h-4 w-4 rounded-full hover:bg-purple-200"
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="px-4 py-2 bg-[#0049ac] text-white rounded-lg hover:bg-[#0049ac]/90"
          >
            Save & Continue
          </button>
        </div>
      </form>
    </div>
  );
}

export default BrandPersonality;